export const PortfolioDetailData = [{
        id: 1,
        title: "Volkan Kıyçak",
        history: "April 10, 2024",
        image: "/assets/images/portfolyo/VolkanKiycak.webp",
        link: "http://volkankiycak.com",
        link2: "www.volkankiycak.com",
        fontfamily: "ROBOTO CONDENSED",
        weight: "REGULAR",
        weight2: "BOLD",
        color: "#0891B2",
        color2: "#04005D",
        color3: " #ffffff",
        backgroundColor: "#0891B2",
        backgroundColor2: "#04005D ",
        backgroundColor3: "#ffffff",
        border: "6.3px solid #056D87",
        siteimages: "/assets/images/portfolyo/VolkanKiycak.webp",
        siteimages2: "/assets/images/portfolyo/VolkanKiycakDetail.webp",
    },
    {
        id: 2,
        title: "Admin Volkan Kıyçak",
        history: "May 4, 2024",
        image: "/assets/images/portfolyo/AdminVolkankiycak2.webp",
        link: "https://admin.volkankiycak.com",
        link2: "www.admin.volkankiycak.com",
        fontfamily: "ROBOTO CONDENSED",
        weight: "REGULAR",
        weight2: "BOLD",
        color: "#0891B2",
        color2: " #04005D",
        color3: " #ffffff",
        backgroundColor: "#0891B2",
        backgroundColor2: " #04005D",
        backgroundColor3: "#ffffff",
        border: "6.3px solid #056D87",
        siteimages: "/assets/images/portfolyo/AdminVolkanKiycakDetail.webp",
        siteimages2: "/assets/images/portfolyo/AdminVolkanKiycakDetail2.webp"
    },
    {
        id: 3,
        title: "Meridyen Terapi",
        history: "June 13, 2024",
        image: "/assets/images/portfolyo/MeridyenTerapi.webp",
        link: "https://istanbulmeridyenterapi.com.tr",
        link2: "www.istanbulmeridyenterapi.com.tr",
        fontfamily: "ROBOTO CONDENSED",
        weight: "REGULAR",
        weight2: "BOLD",
        color: "#1e88c9",
        color2: " #565656",
        color3: " #ffffff",
        backgroundColor: "#1e88c9",
        backgroundColor2: " #565656",
        backgroundColor3: "#ffffff",
        border: "6.3px solid #ebffcc",
        siteimages: "/assets/images/portfolyo/MeridyenTerapi.webp",
        siteimages2: "/assets/images/portfolyo/MeridyenTerapiDetail.webp"
    },
    {
        id: 4,
        title: "Duyu Algı Motor",
        history: "July 22, 2024",
        image: "/assets/images/portfolyo/DuyuAlgiMotor.webp",
        link: "https://www.duyu-algi-motor.com",
        link2: "www.duyu-algi-motor.com",
        fontfamily: "ROBOTO CONDENSED",
        weight: "REGULAR",
        weight2: "BOLD",
        color: "#6A6AF2",
        color2: " #565656",
        color3: " #ffffff",
        backgroundColor: "#6A6AF2",
        backgroundColor2: " #565656",
        backgroundColor3: "#ffffff",
        border: "6.3px solid #4949ff",
        siteimages: "/assets/images/portfolyo/DuyuAlgiMotor.webp",
        siteimages2: "/assets/images/portfolyo/DuyuAlgiMotorDetail.webp"
    },
    {
        id: 5,
        title: "E-Ticaret",
        history: "August 20, 2024",
        image: "/assets/images/portfolyo/Eticaret.webp",
        link: "https://volkankiycak-eticaret.netlify.app/",
        link2: "volkankiycak-eticaret.netlify.app",
        fontfamily: "ROBOTO CONDENSED",
        weight: "REGULAR",
        weight2: "BOLD",
        color: "#1367ef",
        color2: "  #000",
        color3: " #ffffff",
        backgroundColor: "#1367ef",
        backgroundColor2: " #000",
        backgroundColor3: "#ffffff",
        border: "6.3px solid #084dbd",
        siteimages: "/assets/images/portfolyo/Eticaret.webp",
        siteimages2: "/assets/images/portfolyo/EticaretDetail.webp",
    },
    {
        id: 6,
        title: "Trend Mağaza",
        history: "September 12, 2024",
        image: "/assets/images/portfolyo/TrendMagaza.webp",
        link: "https://volkankiycak-trendstore.netlify.app/",
        link2: "volkankiycak-trendstore.netlify.app",
        fontfamily: "ROBOTO CONDENSED",
        weight: "REGULAR",
        weight2: "BOLD",
        color: "#098115",
        color2: "  #000",
        color3: " #ffffff",
        backgroundColor: "#098115",
        backgroundColor2: " #000",
        backgroundColor3: "#ffffff",
        border: "6.3px solid #099329",
        siteimages: "/assets/images/portfolyo/TrendMagaza.webp",
        siteimages2: "/assets/images/portfolyo/TrendMagazaDetail.webp"
    },
    {
        id: 7,
        title: "Pos Application",
        history: "October 19, 2024",
        image: "/assets/images/portfolyo/PosApplication.webp",
        fontfamily: "ROBOTO CONDENSED",
        link: "https://volkankiycak-posapplication.netlify.app/",
        link2: "volkankiycak-posapplication.netlify.app",
        weight: "REGULAR",
        weight2: "BOLD",
        color: "#2563eb",
        color2: "  #000",
        color3: " #ffffff",
        backgroundColor: "#2563eb",
        backgroundColor2: " #000",
        backgroundColor3: "#ffffff",
        border: "6.3px solid #0037AD",
        siteimages: "/assets/images/portfolyo/PosApplication.webp",
        siteimages2: "/assets/images/portfolyo/PosApplicationDetail.webp"
    },
    {
        id: 8,
        title: "Food",
        history: "November 5, 2024",
        image: "/assets/images/portfolyo/Food.webp",
        fontfamily: "ROBOTO CONDENSED",
        link: "https://volkankiycak-food.netlify.app/",
        link2: "volkankiycak-food.netlify.app",
        weight: "REGULAR",
        weight2: "BOLD",
        color: "#e84242",
        color2: "  #000",
        color3: " #ffffff",
        backgroundColor: "#e84242",
        backgroundColor2: " #000",
        backgroundColor3: "#ffffff",
        border: "6.3px solid #ff2323",
        siteimages: "/assets/images/portfolyo/Food.webp",
        siteimages2: "/assets/images/portfolyo/FoodDetail.webp"
    },
    {
        id: 9,
        title: "Stanley",
        history: "December 17, 2024",
        image: "/assets/images/portfolyo/Stanley.webp",
        fontfamily: "ROBOTO CONDENSED",
        link: "https://volkankiycak-stanley.netlify.app/",
        link2: "volkankiycak-stanley.netlify.app",
        weight: "REGULAR",
        weight2: "BOLD",
        color: "#ffD20A",
        color2: "  #000",
        color3: " #ffffff",
        backgroundColor: "#ffD20A",
        backgroundColor2: " #000",
        backgroundColor3: "#ffffff",
        border: "6.3px solid #ddb500",
        siteimages: "/assets/images/portfolyo/Stanley.webp",
        siteimages2: "/assets/images/portfolyo/StanleyDetail.webp"
    },
    {
        id: 10,
        title: "Start Bootstrap",
        history: "January 5, 2025",
        image: "/assets/images/portfolyo/StartBootstrap.webp",
        fontfamily: "ROBOTO CONDENSED",
        link: "https://volkankiycak-startbootstrap.netlify.app/",
        link2: "volkankiycak-startbootstrap.netlify.app",
        weight: "REGULAR",
        weight2: "BOLD",
        color: "#1ABC9B",
        color2: "  #2D3D4F",
        color3: " #ffffff",
        backgroundColor: "#1ABC9B",
        backgroundColor2: " #2D3D4F",
        backgroundColor3: "#ffffff",
        border: "6.3px solid #008369",
        siteimages: "/assets/images/portfolyo/StartBootstrap.webp",
        siteimages2: "/assets/images/portfolyo/StartBootstrapDetail.webp"
    },
      {
        id: 11,
        title: "Emlak Katılım",
        history: "February 25, 2025",
        image: "/assets/images/portfolyo/EmlakKatilim.webp",
        fontfamily: "ROBOTO CONDENSED",
        link: "https://volkankiycak-emlakkatilim.netlify.app/",
        link2: "volkankiycak-emlakkatilim.netlify.app",
        weight: "REGULAR",
        weight2: "BOLD",
        color: "#4f46e5",
        color2: "  #4b5563",
        color3: " #ffffff",
        backgroundColor: "#4f46e5",
        backgroundColor2: " #4b5563",
        backgroundColor3: "#ffffff",
        border: "6.3px solid #2d22ff",
        siteimages: "/assets/images/portfolyo/EmlakKatilim.webp",
        siteimages2: "/assets/images/portfolyo/EmlakKatilimDetail.webp"
    },
    {
        id: 12,
        title: "My Portfolio",
        history: "March 17, 2025",
        image: "/assets/images/portfolyo/MyPortfolio.webp",
        fontfamily: "ROBOTO CONDENSED",
        link: "#",
        link2: "Yakında Yayında...",
        weight: "REGULAR",
        weight2: "BOLD",
        color: "#862121",
        color2: "  #000",
        color3: " #ffffff",
        backgroundColor: "#862121",
        backgroundColor2: " #000",
        backgroundColor3: "#ffffff",
        border: "6.3px solid #5F0000",
        siteimages: "/assets/images/portfolyo/MyPortfolio.webp",
        siteimages2: "/assets/images/portfolyo/MyPortfolioDetail.webp"
    },
    {
        id: 13,
        title: "Film Platformu",
        history: "April 7, 2025",
        image: "/assets/images/portfolyo/FilmPlatformu.webp",
        fontfamily: "ROBOTO CONDENSED",
        link: "#",
        link2: "Yakında Yayında...",
        weight: "REGULAR",
        weight2: "BOLD",
        color: "#FE822A",
        color2: "  #000",
        color3: " #ffffff",
        backgroundColor: "#FE822A",
        backgroundColor2: " #000",
        backgroundColor3: "#ffffff",
        border: "6.3px solid #FF6B01",
        siteimages: "/assets/images/portfolyo/FilmPlatformu.webp",
        siteimages2: "/assets/images/portfolyo/FilmPlatformuDetail.webp"
    },
]